/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_PurchaseInputs */

const en_settings_credits_purchase = /** @type {(inputs: Settings_Credits_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase Credits`)
};

const zh_settings_credits_purchase = /** @type {(inputs: Settings_Credits_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`购买额度`)
};

/**
* | output |
* | --- |
* | "Purchase Credits" |
*
* @param {Settings_Credits_PurchaseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_credits_purchase = /** @type {((inputs?: Settings_Credits_PurchaseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_PurchaseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_credits_purchase(inputs)
	return zh_settings_credits_purchase(inputs)
});
export { settings_credits_purchase as "settings.credits.purchase" }